<template>
  <v-row style="background-color: #803150;margin-left: auto;margin-right: auto">
    <v-col class="py-5 px-10">
      <v-responsive :aspect-ratio="3.6/1">
        <v-container fluid>
          <v-row align="center"
                 justify="center">
            <v-col class=" " style="font-size:36px;color:#ffffff;line-height: 1.2">
              <p class="text-center font-weight-bold text-uppercase">E se non vuoi che te la portiamo…
                ordina e ritira direttamente al mercato! </p>
            </v-col>
             </v-row>
          <v-spacer></v-spacer>
          <v-row align="center"
                 justify="center">
          <v-col class="col-lg-8">
              <v-row>
                <v-col cols="6" class="pa-8">
                  <v-img  src="@/assets/images/delivery-steps/1a.png"></v-img>
                </v-col>
               <v-col cols="6" class="pa-8">
                  <v-img  src="@/assets/images/delivery-steps/2a.png"></v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row style="color:white">
            <v-col cols="12" class="text-uppercase text-center">
              <b style="font-weight: 900" >RITIRO:</b> Mercato Campagna Amica San Teodoro - Via di san Teodoro, 74 - Roma | Sabato e domenica dalle
              8:00 alle 15:00.
            </v-col>

          </v-row>
        </v-container>
      </v-responsive>
    </v-col>
  </v-row>
</template>

  <script>
export default {
  name: "BannerInfo"
}
</script>

<style scoped>

</style>